/** @jsxImportSource @emotion/react */
import { Link } from '@reach/router'
import { css } from '@emotion/react'
import React from 'react'

import { useSizeStyle } from '../../utils/styles/size'

const _Link = ({ children, onClick, block, path, tabIndex, useNewTab, lineHeight, ...props }) => {
  const style = css`
    display: ${block ? 'block' : 'inline-block'};
    ${useSizeStyle(props)}
    border: none;
    margin: 0;
    padding: 0;
    cursor: pointer;
    background: none;
    text-decoration: none;
    color: inherit;
    text-align: left;
    ${lineHeight ? `line-height: ${lineHeight};` : 'line-height: 0;'}
  `

  if (useNewTab) {
    return (
      <a className="link" css={style} href={path} target="_blank" rel="noreferrer" {...props}>
        {children}
      </a>
    )
  }

  if (path) {
    return (
      <Link className="link" css={style} onClick={onClick} to={path} tabIndex={tabIndex} {...props}>
        {children}
      </Link>
    )
  }

  return (
    <button className="link" css={style} onClick={onClick} type="button" tabIndex={tabIndex}>
      {children}
    </button>
  )
}

export default _Link
